interface IIosWindow {
	webkit: {
		messageHandlers: {
			logout: {
				postMessage(value: ''): void;
			};
		};
	};
}

const win = (window as any) as IIosWindow;

export function nativeLogoutIos() {
	win.webkit.messageHandlers.logout.postMessage('');
}
